/**
 * Longest single dictation session. Audio streams to a metered Gateway model
 * for as long as the mic is on, so a forgotten session ends on its own.
 */
export const MAX_DICTATION_SESSION_MINUTES = 5
